import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import styled from '@emotion/styled';
import { useIsMobile } from '@stores/AppCommonData';
import Logo from '@comp/Logo/Logo';
import { mobile } from '@styles/index';
import CombatsInfo from './CombatsInfo';
import CombatsHeader from './CombatsHeader';
import CombatsRoadmap from './CombatsRoadmap';
import CombatFooter from './CombatFooter';
import Steps from './Steps';
import CombatFAQs from './CombatFAQs';
import CombatAlgo from './CombatAlgo';

const Header = styled.div`
  height: 72px;
  position: absolute;
  top: 0;
  display: flex;
  width: 100%;
`;

const HeaderWrapper = styled.div`
  max-width: 1136px;
  margin: auto;
  flex: 1;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    max-width: 90%;
  }
`;

const Combat = () => {
  const isMobile = useIsMobile();
  const router = useRouter();

  const onHeaderEnroll = () => {
    document
      .getElementById('contests-enroll')
      .scrollIntoView({ behavior: 'smooth' });
  };

  const onLearnMoreClick = () => {
    document
      .getElementById('contests-roadmap')
      .scrollIntoView({ behavior: 'smooth' });
  };

  const { query } = router;
  const data = useSelector(({ combats }) => combats.staticData[query.goalUID]);

  if (!data) return null;

  return (
    <>
      {/* {query.inside_app !== 'true' && <ContestHeader quoteRef={quoteRef} />} */}
      <Header>
        <HeaderWrapper>
          <Logo isReload={isMobile} />
        </HeaderWrapper>
      </Header>
      <CombatsHeader
        goalUID={query.goalUID}
        isMobile
        onEnroll={onHeaderEnroll}
        onLearnMore={onLearnMoreClick}
      />
      <CombatsRoadmap goalUID={query.goalUID} isMobile />
      <CombatAlgo goalUID={query.goalUID} />
      {!isMobile && <Steps goalUID={query.goalUID} />}
      <CombatsInfo />
      <CombatFAQs goalUID={query.goalUID} />
      <CombatFooter goalUID={query.goalUID} />
    </>
  );
};

export default Combat;
